"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.CLOSE_ICON = exports.MODAL = exports.MODAL_CONTAINER = void 0;

var _rodalDialog,
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var MODAL_CONTAINER = (0, _cxs["default"])({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  animationDuration: "100ms !important",
  "> .rodal-mask": {
    background: "rgba(0, 0, 0, .9);"
  },
  "> .rodal-dialog": (_rodalDialog = {
    background: _vars.COLOURS.grey.athens.parthenon,
    borderRadius: "12px",
    padding: 0,
    marginTop: "5px",
    marginBottom: "5px",
    position: "relative !important",
    height: "auto !important",
    maxHeight: "calc(100% - 10px)",
    display: "flex",
    flexDirection: "column",
    maxWidth: "1080px",
    minWidth: "40%",
    width: "auto !important"
  }, (0, _defineProperty2["default"])(_rodalDialog, _vars.MEDIA_QUERIES.medium, {
    width: "60% !important"
  }), (0, _defineProperty2["default"])(_rodalDialog, _vars.MEDIA_QUERIES.small, {
    width: "calc(100% - 10px) !important"
  }), _rodalDialog)
});
exports.MODAL_CONTAINER = MODAL_CONTAINER;

var MODAL = function MODAL() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
  return (0, _cxs["default"])(_objectSpread((0, _defineProperty2["default"])({
    display: "flex",
    height: "100%",
    overflowY: "auto",
    flexDirection: "column",
    padding: "50px"
  }, _vars.MEDIA_QUERIES.small, {
    padding: "50px 30px 30px"
  }), a));
};

exports.MODAL = MODAL;
var CLOSE_ICON = (0, _cxs["default"])({
  cursor: "pointer",
  position: "absolute",
  top: "30px",
  right: "30px"
});
exports.CLOSE_ICON = CLOSE_ICON;